import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import CommentIcon from "@mui/icons-material/Comment";

import { Common } from "../../helper";
import { CommentValidationSchema } from "../../validators";

import "../../assets/stlyes/CommonModal.css";

import SaveIcon from "../../assets/images/Save.png";

const CommonModal = (props) => {
  const { show, _description, comment, finalUpdatedData, index, pupilMarkss, grade, setworkingComment, setbelowComment, setexpectedComment, setgreaterComment, _markings } = props;
  const [showModal, setShowModal] = useState(show);

  useEffect(() => {
    setShowModal(show);
  }, [show])

  const handleClose = () => {
    setShowModal(false);
    props.close();
  }
  const setData = (values) => {
    finalUpdatedData.pupilId[index].comment = values.comment
    grade === "B" ? setbelowComment(values.comment) : grade === "W" ? setworkingComment(values.comment) : grade === "E" ? setexpectedComment(values.comment) : setgreaterComment(values.comment);
    pupilMarkss(finalUpdatedData && finalUpdatedData)
    handleClose()
  }

  return (
    <Modal show={showModal} onHide={handleClose} dialogClassName={""} >
      <>
        <Modal.Title className="d-flex justify-content-between ModalHeader">
          <div className="pupilNameDiv"><CommentIcon /> {Common.Comment} {_markings[index].firstName} {_markings[index].lastName}</div>
          <div className="pupilNameDiv" style={{ textAlign: "left" }}>{_description}</div>
        </Modal.Title>
        <Modal.Body>
          <Formik initialValues={{ comment: comment ? comment : "" }}
            isInitialValid
            validationSchema={CommentValidationSchema}
            onSubmit={(values) => {
              setData(values)
            }}>
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <Form.Control
                    as="textarea"
                    type="text"
                    name="comment"
                    placeholder="Add Comment"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.comment}
                    className={touched.comment && errors.comment ? "array-answer" : "array-answer"}
                    autoComplete="off"
                  />
                  {touched.comment && errors.comment ? (<p className="error-message">{errors.comment}</p>) : <p>{""}</p>}
                </Form.Group>
                <div className="submit-button-div d-flex justify-content-end">
                  <button
                    className="cancelButton"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    {Common.Cancel}
                  </button>&nbsp;
                  <button className="saveButton" type="submit"><img src={SaveIcon} alt="Save" />{Common.SaveComment}</button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </>
    </Modal>
  );
}

export { CommonModal };